import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../data-structures/results/result-row.model";

interface CFIAInterface {
  'RESULTS.DATA.CASHFLOWS.PPAE'?: ResultRow;
}
export class CFIA {
  'RESULTS.DATA.CASHFLOWS.PPAE';
  get ppae() {
    return this['RESULTS.DATA.CASHFLOWS.PPAE'];
  }
  set ppae(value: ResultRow) {
    this['RESULTS.DATA.CASHFLOWS.PPAE'] = value;
  }
  constructor(param: CFIAInterface = {}) {
    this['RESULTS.DATA.CASHFLOWS.PPAE'] = param['RESULTS.DATA.CASHFLOWS.PPAE']
      ? new ResultRow(param['RESULTS.DATA.CASHFLOWS.PPAE'])
      : new ResultRow();
  }

  deepCopy() {
    return new CFIA(cloneDeep(this));
  }
}